export default <T extends { readonly name: string }>(a: T, b: T) =>
  a.name < b.name ? -1 : 1;
